export default "__VITE_PUBLIC_ASSET__e237c54d__"